interface UniquePayProp {
	disabled?: boolean;
}

export const UniquePayIcon = ({ disabled }: UniquePayProp) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
		<g id="Icon / 1 link">
			<path
				id="Vector"
				d="M6.19271 13.516L13.3594 6.34937"
				stroke={disabled ? '#B8B8BB' : '#636172'}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Vector_2"
				d="M13.3594 23.6508L13.3594 6.34937"
				stroke={disabled ? '#B8B8BB' : '#636172'}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Vector_3"
				d="M20.0557 12.7039L23.2074 9.55174M21.1063 7.97568L21.3495 7.69409C21.8421 7.20147 22.5102 6.92476 23.2068 6.9248C23.9035 6.92485 24.5715 7.20167 25.0641 7.69435C25.5566 8.18703 25.8333 8.85522 25.8333 9.55193C25.8332 10.2486 25.5564 10.9168 25.0638 11.4094L24.7833 11.6532M22.1569 14.2799L21.9483 14.5605C21.4498 15.0531 20.7772 15.3294 20.0764 15.3294C19.3756 15.3294 18.7031 15.0531 18.2046 14.5605C17.9588 14.3176 17.7636 14.0284 17.6305 13.7096C17.4973 13.3907 17.4287 13.0486 17.4287 12.7031C17.4287 12.3575 17.4973 12.0154 17.6305 11.6966C17.7636 11.3778 17.9588 11.0885 18.2046 10.8457L18.4798 10.6025"
				stroke={disabled ? '#B8B8BB' : '#636172'}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
